import { isNil } from 'lodash';

const recaptchaScriptId = 'rec-recaptcha';

const isReady = () => {
    return window && !!window.grecaptcha;
};

const isLoaded = () => {
    return !isNil(document.scripts.namedItem(recaptchaScriptId));
};

export const execute = (captchaKey, action, onVerify) => {
    return window.grecaptcha.ready(() => {
        try {
            return window.grecaptcha.execute(captchaKey, { action }).then((token) => onVerify({token}));
        }
        catch (err) {
            return onVerify({error: err.message});
        }
    });
};

/* eslint-disable consistent-return */
export const getRecaptchaV3 = (captchaKey, action, onVerify) => {
    if (isLoaded()) {
        const onWait = setInterval(() => {
            if (isReady()) {
                execute(captchaKey, action, onVerify);
                clearInterval(onWait);
            }
        }, 100);
    }
    else {
        return onVerify({error: "recaptcha script not detected."});
    }
};

export const loadScript = (key) => {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
  script.async = true;
  script.defer = true;
  script.id = recaptchaScriptId;
  document.body.appendChild(script);
};